module.exports = __webpack_public_path__ + "img/user-handsel.fc256672.png";